<aside class="card">
  <div class="border-paddng">
    <div class="border cm-scrollbar cm-table-w-scroll table-responsive web-display-only">
      <table class="table table-hover table-sm">
        <caption style="display: none;">NYCHA Capital Needs</caption>
        <thead>
          <tr class="grid-header">
            <th scope="col" class="text-middle" rowspan="2">Area of Work</th>
            <th scope="col" colspan="2">
              <div>
                <div class="capital-need-text">Capital Needs</div>
                <hr />
                <div class="row">
                  <div class="col-6 text-align-center">5-Year</div>
                  <div class="col-6 text-align-center">20-Year</div>
                </div>
              </div>
            </th>
            <th scope="col" class="text-middle content-padding" rowspan="2">
              <span>Projects</span><span class="header-year"> (Since 2019)</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of projectDetails; index as i" class="bottom-border">
            <td class="text-middle">
              {{ item.name }}
            </td>
            <td class="text-align-right currency-bg">
              {{ item.fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </td>
            <td class="text-align-right currency-bg">
              {{ item.twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </td>
            <td class="projectLink text-middle content-padding">
              <button
                *ngFor="let project of item.projects"
                type="button"
                class="button button-underline list-group-item list-group-item-action"
                (click)="loadProjectDetails(project.id)"
              >
                <span>
                  {{ project.name | titleCasewithAvoidWords | simplifyWords }}
                  <i class="chevron-double-right"></i
                ></span>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="grid-footer">
            <th scope="col" class="footer-text-center">Total</th>
            <th scope="col" class="footer-text-center text-align-right">
              {{ fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </th>
            <th scope="col" class="footer-text-center text-align-right">
              {{ twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
            </th>
            <th scope="col" class="content-padding">
              <div class="row">
                <div class="col-lg-6" style="padding-top: 5px">
                  {{ _development.totalInvestment | currency : "USD" : "$" : "1.0-0" }}
                </div>
                <div class="col-lg-6 content-position">
                  <div class="excel-export">
                    <span class="nav-link text-dark excel-export-button" (click)="downloadCSV()"
                      >Export CSV </span
                    ><span class="img-export"
                      ><img src="assets/img/icons/vector.svg" alt="..." class="d-none d-md-block"
                    /></span>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="expansion-panel">
      <div class="expansion-panel-header">AREA OF WORK</div>
      <app-expansion-panel-group
        [projectDetails]="projectDetails"
        (loadProject)="loadProjectDetails($event)"
      ></app-expansion-panel-group>
    </div>
  </div>
  <div class="border-paddng print-pdf-only">
    <table class="table table-hover">
      <caption style="display: none;">NYCHA Capital Needs</caption>
      <thead>
        <tr class="grid-header">
          <th scope="col" class="text-middle" rowspan="2">Area of Work</th>
          <th scope="col" colspan="2">
            <div>
              <div class="capital-need-text">Capital Needs</div>
              <div class="row">
                <div class="col-6 text-align-center">5-Year</div>
                <div class="col-6 text-align-center">20-Year</div>
              </div>
            </div>
          </th>
          <th scope="col" class="text-middle content-padding" rowspan="2">
            <span>Projects</span><span class="header-year"> (Since 2019)</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- <tr class="grid-header">
          <th scope="col" class="text-middle" rowspan="2">Area of Work</th>
          <th scope="col" colspan="2" class="capital-need-text">Capital Needs</th>
          <th scope="col" class="text-middle content-padding" rowspan="2">
            <span>Projects</span><span class="header-year"> (Since 2019)</span>
          </th>
        </tr>
        <tr class="grid-header">
          <th scope="col">
            <div class="text-align-center">5-Year</div>
          </th>
          <th scope="col">
            <div class="text-align-center">20-Year</div>
          </th>
        </tr> -->
        <tr *ngFor="let item of projectDetails; index as i" class="bottom-border">
          <td class="text-middle">
            {{ item.name }}
          </td>
          <td class="text-middle currency-bg">
            {{ item.fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
          </td>
          <td class="text-middle currency-bg">
            {{ item.twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}
          </td>
          <td class="projectLink text-middle content-padding">
            <button
              *ngFor="let project of item.projects"
              type="button"
              class="button button-underline list-group-item list-group-item-action"
              (click)="loadProjectDetails(project.id)"
            >
              <span>
                {{ project.name | titleCasewithAvoidWords | simplifyWords }}
                <i class="chevron-double-right"></i
              ></span>
            </button>
          </td>
        </tr>
        <tr class="sticky-bottom grid-footer print-border">
          <th scope="col">Total</th>
          <th scope="col">{{ fiveYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}</th>
          <th scope="col">{{ twentyYearCapitalNeeds | currency : "USD" : "$" : "1.0-0" }}</th>
          <th scope="col" class="content-padding">
            <div class="row">
              <div class="col-lg-6">
                {{ _development.totalInvestment | currency : "USD" : "$" : "1.0-0" }}
              </div>
              <div class="col-lg-6 content-position">
                <div class="excel-export">
                  <span class="nav-link text-dark excel-export-button" (click)="downloadCSV()"
                    >Export CSV </span
                  ><span class="img-export"
                    ><img src="assets/img/icons/vector.svg" alt="..." class="d-none d-md-block"
                  /></span>
                </div>
              </div>
            </div>
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</aside>
